import { BOGeneralValues } from "./BOGeneralValues.model";

export class BOPrincipalMedicDiagnostic extends BOGeneralValues{
    id:number;
    diseaseCode:string;
    orphanDisease:string;
    diseaseName:string;
    diagnosticType:string;
}